// extracted by mini-css-extract-plugin
export default {"contentContainer":"ContentWrapper-module__contentContainer__IR2nYBK"};